import React from 'react';
import axios from 'axios';
import Head from 'next/head';
import {debounce} from "lodash";
import {
    NSPageCart, NSContext, NSToast, imgDefaultBase64, jwtManager
} from 'aqlrc';
import { Link, Router } from '../routes';
import CodePromo from '../components/CodePromo';
import Layout from '../components/Layout';
import getAPIUrl from '../lib/getAPIUrl';
import { formatPrice } from '../lib/utils';
import { withI18next } from '../lib/withI18n';

class PageCart extends NSPageCart {
    static getInitialProps = async function (ctx) {
        const { lang }        = ctx.nsGlobals;
        const taxDisplay      = jwtManager.getTaxDisplay(ctx); // HT ou TTC
        const countries       = await axios.post(`${getAPIUrl(ctx)}v2/territories`, { PostBody: { filter: { type: 'country' }, limit: 99 }, lang });
        const selectedCountry = countries.data.datas.find((country) => country.code.toLowerCase() === lang.toLowerCase());
        const cmsLegalCart = await axios.post(`${getAPIUrl(ctx)}v2/component/ns-cms/legalCart`, { lang });

        return {
            taxDisplay,
            countries    : countries.data.datas,
            countryCode  : selectedCountry && selectedCountry.code ? selectedCountry.code : 'FR',
            cmsLegalCart : cmsLegalCart.data
        };
    };

    componentDidMount = async () => {
        try {
            const { lang } = this.props;
            window.localStorage.removeItem('filters');
            const cartId = window.localStorage.getItem('cart_id');
            if (!cartId || cartId == null) {
                return NSToast.warn('cart:error.emptyCart');
            }
            window.addEventListener('discountAdded', this.discountAddedListener);

            const resCart = await axios.post(`${getAPIUrl()}v2/cart/${cartId}`, { lang, PostBody: { populate: ['items.id'] } });
            if (resCart.status === 204) {
                throw 'error get cart';
            }
            if (resCart.data) {
                this.setState({ cart: resCart.data });
            }
        } catch (e) {
            console.error(e);
            window.localStorage.removeItem('cart_id');
            NSToast.error('cart:error.getCartError');
        }
    }

    qtyModifier = async (qty, idx) => {
        const { cart } = this.state;

        let itemId = '';
        let item = {};
        itemId = cart.items[idx]._id;
        item = cart.items.find((it) => it._id === itemId);
        try {
            item.quantity = qty;
            const response = await axios.put(`${getAPIUrl()}v2/cart/updateQty`, {
                item   : { _id: item._id, quantity: item.quantity },
                cartId : window.localStorage.getItem('cart_id')
            });
            if (response) {
                this.setState({ cart: response.data });
                const event = new CustomEvent('updateCart', { detail: { cart: response.data } });
                window.dispatchEvent(event);
            }
        } catch (error) {
            console.error(error);
        }
    };

    validateCart = (Router = undefined) => {
        const { routerLang, user, cart } = this.state;
        try {
            if (cart === undefined || cart.items === undefined || cart.items.length === 0) {
                return NSToast.error('cart:error.emptyCart');
            }
            if (document.querySelector('#check-agree').checked !== true) {
                return NSToast.error('cart:error.check_conditions');
            }
            if (!user) {
                return Router.pushRoute('cartLogin', { lang: routerLang });
            }
            Router.pushRoute('cartAddress', { lang: routerLang });
        } catch (error) {
            console.error(error);
            Router.pushRoute('cartLogin', { lang: routerLang });
        }
    };

    editComment = debounce(async () => {
        const { cart } = this.state;
        const res = await axios.put(`${getAPIUrl()}v2/cart/comment`, { cartId: window.localStorage.getItem('cart_id'), comment: cart.comment });
        if (res.status === 200) {
            cart.comment = res.data.comment;
            this.setState({ cart });
        }
    }, 1000)

    render() {
        const {
            cmsLegalCart, lang, oCmsHeader, oCmsFooter, routerLang, sitename, t
        } = this.props;
        const {
            cart, countries, countryCode, taxDisplay
        } = this.state;
        let totalDiscount = 0;
        if (cart.promos && cart.promos.length) {
            for (let i = 0; i < cart.promos.length; i++) {
                totalDiscount += cart.promos[i].discountET;
            }
        }
        return (
            <NSContext.Provider value={{ props: this.props, state: this.state, onLangChange: (l) => this.onLangChange(l) }}>
                <Layout header={oCmsHeader.content} footer={oCmsFooter.content}>
                    <Head>
                        <title>{sitename} | {t('cart:title')}</title>
                        <meta property="og:type" content="website" />
                    </Head>
                    <div className="main">
                        <div className="intro-alt">
                            <div className="decoration-arrow color-white">
                                <div className="decoration__img bg-purple" />{/* <!-- /.decoration__img --> */}
                            </div>{/* <!-- /.decoration-arrow --> */}
                        </div>{/* <!-- /.intro-alt --> */}

                        <div className="section section--cart form">
                            <form action="?" method="post">
                                <div className="section__inner">
                                    <div className="shell">
                                        <div className="section__cols">
                                            <div className="section__main">
                                                <div className="article">
                                                    <h1>{t('cart:titleCol1')}</h1>
                                                </div>{/* <!-- /.article --> */}
                                                {
                                                    cart && cart.items && cart.items.length > 0 ? (
                                                        cart.items.map((item, index) => {
                                                            let imgDefault = imgDefaultBase64;
                                                            let imgAlt = 'illustration produit';
                                                            if (item.id.images && item.id.images.length) {
                                                                const foundImg = item.id.images.find((img) => img.default);
                                                                if (foundImg) {
                                                                    imgDefault = foundImg._id !== 'undefined' ? `/images/products/105x197/${foundImg._id}/${item.id.slug[lang]}${foundImg.extension}` : imgDefault;
                                                                    imgAlt = foundImg.alt || imgAlt;
                                                                } else {
                                                                    imgDefault = item.id.images[0]._id !== 'undefined' ? `/images/products/105x197/${item.id.images[0]._id}/${item.id.slug[lang]}${item.id.images[0].extension}` : imgDefault;
                                                                    imgAlt = item.id.images[0].alt || imgAlt;
                                                                }
                                                            }
                                                            const price = item.price && item.price.special ? item.price.special.et * item.quantity : item.price.unit.et * item.quantity;
                                                            return (
                                                                <div className="card-cart" key={item._id}>
                                                                    <div className="image image--1" style={{ backgroundImage: `url(${imgDefault})` }} />{/* <!-- /.image --> */}

                                                                    <div className="card__content">
                                                                        <div className="card__main">
                                                                            <div className="card__quantity">
                                                                            x {item.quantity}
                                                                            </div>{/* <!-- /.card__quantity --> */}

                                                                            <div className="article">
                                                                                <h2>{item.name}</h2>

                                                                                {item.id.description2 && item.id.description2.title && <h3>{item.id.description2.title}</h3>}

                                                                                {item.id.attributes && item.id.attributes.find((a) => a.code === 'developper') && item.id.attributes.find((a) => a.code === 'developper').value && <p>{t('cart:by')} {item.id.attributes.find((a) => a.code === 'developper').value}</p>}
                                                                            </div>{/* <!-- /.article --> */}
                                                                        </div>{/* <!-- /.card__main --> */}

                                                                        <div className="card__aside">
                                                                            <div className="card__actions">
                                                                                <button type="button" onClick={(e) => this.deleteProduct(index)}>{t('cart:delete')}</button>
                                                                            </div>{/* <!-- /.card__actions --> */}

                                                                            <div className="price">
                                                                                {
                                                                                    item.price.special && item.price.special.et > 0 && (<del>{formatPrice(item.price.unit.et * item.quantity)} {t('cart:et')}</del>)
                                                                                }

                                                                                {price > 0 ? <>{formatPrice(price)} {t('cart:et')}</> : t('cart:free')}
                                                                            </div>{/* <!-- /.price --> */}
                                                                        </div>{/* <!-- /.card__aside --> */}
                                                                    </div>{/* <!-- /.card__content --> */}
                                                                </div>/* <!-- /.card-cart --> */
                                                            );
                                                        })
                                                    ) : <div className="card-cart"><div className="card__content">{t("cart:empty")}</div></div>
                                                }

                                                <div className="article order-comment-container" hidden={!cart || !cart.items.length}>
                                                    <div className="article__actions">
                                                        <input className="order-comment" type="text" placeholder={t("cart:placeholder.orderComment")} onChange={e => this.setState({cart: {...cart, comment: e.target.value}}, this.editComment)} value={cart.comment} />
                                                    </div>{/* <!-- /.article__actions --> */}
                                                </div>{/* <!-- /.article --> */}
                                                <div className="article">
                                                    <p dangerouslySetInnerHTML={{ __html: cmsLegalCart.content }} />

                                                    <div className="article__actions">
                                                        <Link route="home" params={{ lang: routerLang }}>
                                                            <a className="btn btn--color color-purple">
                                                                <span className="btn__content">{t('cart:btn.continueShopping')}</span>
                                                            </a>
                                                        </Link>
                                                    </div>{/* <!-- /.article__actions --> */}
                                                </div>{/* <!-- /.article --> */}
                                            </div>{/* <!-- /.section__main --> */}

                                            <div className="sidebar-alt" hidden={!cart || !cart.items.length}>
                                                <div className="article">
                                                    <div className="h1">{t('cart:titleCol2')}</div>
                                                </div>{/* <!-- /.article --> */}

                                                <div className="sidebar__entry">
                                                    <div className="box bg-blue color-white">
                                                        <div className="bill">
                                                            <div className="bill__group">
                                                                <div className="bill__row">
                                                                    <div className="bill__col">
                                                                        {t('cart:cartTotal')}
                                                                    </div>{/* <!-- /.bill__col --> */}

                                                                    <div className="bill__col">
                                                                        {cart && formatPrice(cart.priceSubTotal.et)}
                                                                    </div>{/* <!-- /.bill__col --> */}
                                                                </div>{/* <!-- /.bill__row --> */}
                                                                {
                                                                    totalDiscount > 0 && (
                                                                        <div className="bill__row">
                                                                            <div className="bill__col">
                                                                                {t('cart:discountApply')}
                                                                            </div>{/* <!-- /.bill__col --> */}

                                                                            <div className="bill__col">
                                                                            -{formatPrice(totalDiscount)}
                                                                            </div>{/* <!-- /.bill__col --> */}
                                                                        </div>/* <!-- /.bill__row --> */
                                                                    )
                                                                }
                                                            </div>{/* <!-- /.bill__group --> */}

                                                            <div className="bill__group">
                                                                <div className="bill__row">
                                                                    <div className="bill__col">
                                                                        {t('cart:totalEt')}
                                                                    </div>{/* <!-- /.bill__col --> */}

                                                                    <div className="bill__col">
                                                                        {cart && formatPrice(cart.priceTotal.et)}
                                                                    </div>{/* <!-- /.bill__col --> */}
                                                                </div>{/* <!-- /.bill__row --> */}

                                                                <div className="divider" />{/* <!-- /.divider --> */}

                                                                <div className="bill__row">
                                                                    <div className="bill__col">
                                                                        <strong>{t('cart:totalAti')}</strong>
                                                                    </div>{/* <!-- /.bill__col --> */}

                                                                    <div className="bill__col">
                                                                        {cart && formatPrice(cart.priceTotal.ati)}
                                                                    </div>{/* <!-- /.bill__col --> */}
                                                                </div>{/* <!-- /.bill__row --> */}
                                                            </div>{/* <!-- /.bill__group --> */}
                                                        </div>{/* <!-- /.bill --> */}

                                                        <div className="code">
                                                            <CodePromo />
                                                        </div>{/* <!-- /.code --> */}

                                                        <div className="checkbox-alt">
                                                            <input type="checkbox" id="check-agree" />

                                                            <label htmlFor="check-agree">{t('cart:check_conditions')}</label>
                                                        </div>{/* <!-- /.checkbox-alt --> */}

                                                        <div className="box__actions">
                                                            <button type="button" className="btn box__btn" onClick={() => this.validateCart(Router)}>
                                                                <span className="btn__content">{t('cart:btn.validCart')}</span>
                                                            </button>
                                                        </div>{/* <!-- /.box__actions --> */}
                                                    </div>{/* <!-- /.box --> */}
                                                </div>{/* <!-- /.sidebar__entry --> */}

                                                <div className="sidebar__entry">
                                                    <div className="box-alt color-orange">
                                                        <i className="ico-secure" />
                                                    </div>{/* <!-- /.box-alt --> */}
                                                </div>{/* <!-- /.sidebar__entry --> */}
                                            </div>{/* <!-- /.sidebar-alt --> */}
                                        </div>{/* <!-- /.section__cols --> */}
                                    </div>{/* <!-- /.shell --> */}
                                </div>{/* <!-- /.section__inner --> */}
                            </form>
                        </div>{/* <!-- /.section --> */}
                    </div>{/* <!-- /.main --> */}
                    <style jsx>{`
                        .order-comment-container {
                            height: 30px;
                        }
                        .order-comment {
                            border: 1px solid grey;
                            padding: 10px 20px 9px;
                            max-width: 300px;
                            float: right;
                        }
                        @media screen and (max-width: 767px) {
                            .order-comment {
                                max-width: 100%;
                            }
                        }
                    `}</style>
                </Layout>
            </NSContext.Provider>
        );
    }
}

export default withI18next(['cart', 'common'])(PageCart);
